import * as React from 'react';
import './organization-status-log.scss';
import { Button, Icon } from '@teamsnap/teamsnap-ui';
import { DateFormat, DateService } from 'frontend-toolkit';

interface Props {
  items: any;
}

const OrgStatusLog = ({ items }: Props) => {
  const [showLog, setShowLog] = React.useState(false);

  const toggleLog = () => {
    setShowLog(!showLog);
  };

  const dateFormat = (date) => {
    const unformattedTransactedAtTime = new Date(date);

    return DateService.dateToString(unformattedTransactedAtTime, DateFormat.DATE_WITH_TIME);
  };

  return (
    <div className="status-log__container">
      <div className="status-log__actions">
        <Button type="link" onClick={toggleLog}>
          {showLog ? 'HIDE' : 'SHOW'} HISTORY LOG <Icon name={showLog ? 'up' : 'down'} />
        </Button>
      </div>
      {showLog && (
        <ul className="status-log">
          {items.map((item) => (
            <li className="status-log__item" key={item.id}>
              {`${item.description} on ${dateFormat(item.transactedAt)}`}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OrgStatusLog;
